<template>
  <div>
    <div class="second-bar-admin">
      <v-row>
        <v-col cols="12" class="pt-0 pb-0">
          <CountStatusUIv2
            :filterForm="filterForm"
            :totalContactModule="totalContactModule"
            :typeHeaderContactModule="computedTypeHeaderStatusModule"
            :contactModuleList="countStatusModuleList"
          />
        </v-col>
      </v-row>
    </div>
    <SpecialCareStudentTable @show-modal-quick-view="handleOpenQuickView"></SpecialCareStudentTable>
  </div>
</template>

<script>
import SpecialCareStudentTable
from '@/modules/student_care/components/special_care/SpecialCareStudentTable.vue';
import { mapState } from 'vuex';
import CountStatusUIv2 from '@/components/common/CountStatusUIv2/index.vue';

export default {
  name: 'SpecialCareStudentTab',
  components: { SpecialCareStudentTable, CountStatusUIv2 },
  props: {
    filterForm: {
      type: Object,
      default: () => {
      },
    },
  },
  methods: {
    handleOpenQuickView(item, logFilter) {
      this.$emit('show-modal-quick-view', item, logFilter);
    },
  },
  computed: {
    ...mapState('student_care', ['totalContactModule', 'typeHeaderStatusModule', 'countStatusModuleList']),
    computedTypeHeaderStatusModule() {
      return this.typeHeaderStatusModule ? this.typeHeaderStatusModule.slice(0, -2) : this.typeHeaderStatusModule;
    },
  },
};
</script>

<style scoped>
.second-bar-admin {
  margin-top: 28px;
  margin-bottom: 28px;
}
</style>
